module.exports = __webpack_public_path__ + "static/media/36-10.08ff334c.mp3";